import * as React from 'react';
import $ from 'jquery';
// This should be imported after jquery for its side effects
import 'bootstrap/js/dist/collapse';

import './Toast.scss';

const useToast = (text: string, text2?: string) => {
  // If multiple toasts are used in a page, we want to target them separately
  const id = React.useMemo(
    () => `id-${Math.random().toString(36).substring(7)}`,
    []
  );

  const ref = React.useRef<number>();
  const clearTimer = React.useCallback(() => clearTimeout(ref.current), [ref]);
  React.useEffect(() => clearTimer, [clearTimer]);

  return {
    show: () => {
      clearTimer();
      const toastElement = $(`#${id}`);
      toastElement.collapse('show');
      ref.current = window.setTimeout(
        () => toastElement.collapse('hide'),
        3000
      );
    },
    render: (
      <div id={id} className='collapse'>
        <div
          className='d-flex justify-content-center bg-color--dark fcolor--global-white'
          role='alert'
          aria-live='assertive'
          aria-atomic='true'
          style={{
            position: 'fixed',
            width: '100%',
            bottom: 0,
            left: 0,
            fontWeight: 700,
            fontSize: '16px',
          }}
        >
          {text2 ? (
            <div className='m-4 toast-2-container'>
              <div className='toast-bold'>{text2}</div>
              <div>{text}</div>
            </div>
          ) : (
            <div className='m-4'>{text}</div>
          )}
        </div>
      </div>
    ),
  };
};

export default useToast;
